module.exports = __webpack_public_path__ + "img/silicium-single-crystal.5415532b.png";